import {ApplicationStoreType} from 'desktop/store';

/**
 * Get states
 */
export const getAllStates = (store: ApplicationStoreType) => store.location.states;

/**
 * Get states
 */
export const getStatesSelector = (store: ApplicationStoreType, country: string) =>
    store.location.states[country];
